//获取当前时间
const now = new Date();
const state = {
    statusOptions: [{
            name: '初诊',
            id: '1',
        },
        {
            name: '复诊',
            id: '2',
        },
    ],
    floorOptions: [{
            name: '2楼',
            id: '2楼',
        }, {
            name: '3楼',
            id: '3楼',
        },
        {
            name: '12楼',
            id: '12楼',
        },
    ],
    areaOptions: [{
        areaName: '上伯',
        areaCode: '001'
    }, {
        areaName: '上百',
        areaCode: '002'
    }, {
        areaName: '上翡',
        areaCode: '003'
    }, {
        areaName: '北百',
        areaCode: '004'
    }, {
        areaName: '温伯',
        areaCode: '005'
    }, {
        areaName: '重百',
        areaCode: '006'
    }, {
        areaName: '南伯',
        areaCode: '007'
    }],
    sexey: [{
        label: '男',
        value: '0'
    }, {
        label: '女',
        value: '1'
    }, ],
    flagOption: [{
            name: '无',
            id: '无',
        }, {
            name: 'VIP',
            id: 'VIP',
        },
        // {
        //     name: '1星',
        //     id: '1星',
        // }, {
        //     name: '2星',
        //     id: '2星',
        // }, {
        //     name: '3星',
        //     id: '3星',
        // }, {
        //     name: '4星',
        //     id: '4星',
        // }, {
        //     name: '5星',
        //     id: '5星',
        // },
    ],
    nameOptions: [{
            name: '购买',
            id: '1',
        },
        {
            name: '退款',
            id: '2',
        },
    ],
    projects: [],
    createByList: [],
    list: [],
    list1: [], //医生
    list2: [], //护士
    list3: [], //咨询师
    list4: [], //医助
    products: [], //项目名称
    materList: [], //耗材列表
    nurseList: [{
        id: 1,
        name: '刘丽贺',
    }, {
        id: 2,
        name: '许倩',
    }, {
        id: 3,
        name: '马苗苗',
    }, {
        id: 4,
        name: '易小媛',
    }, {
        id: 5,
        name: '刘洁',
    }, {
        id: 6,
        name: '项璐',
    }, {
        id: 7,
        name: '韩东宇',
    }, {
        id: 8,
        name: '石茜茜',
    }, {
        id: 9,
        name: '郑亚兰',
    }, {
        id: 10,
        name: '方霏',
    }, {
        id: 11,
        name: '朱园园',
    }, {
        id: 12,
        name: '张智会',
    }, {
        id: 13,
        name: '殷丽娜',
    }, {
        id: 14,
        name: '吴嘉琪',
    }, {
        id: 15,
        name: '段乾岚',
    }, {
        id: 16,
        name: '蒋菁怡',
    }, {
        id: 17,
        name: '朱丹',
    }, {
        id: 18,
        name: '金爱敏',
    }],
    // 外科配置
    optionsStatus: [{
            value: 1,
            label: '场地',
        },
        {
            value: 2,
            label: '麻醉方式',
        },
        // {
        //     value: 11,
        //     label: '麻醉医生',
        // },
        // {
        //     value: 12,
        //     label: '洗手护士、巡回护士',
        // },
        // {
        //     value: 13,
        //     label: '主刀医生、实际手术医生',
        // },
        // {
        //     value: 14,
        //     label: '副刀医生、医助姓名',
        // },

    ],
    // 注射微整科配置
    skinOption: [{
            value: 2,
            label: '麻醉方式',
        },
        {
            value: 9,
            label: '注射部位',
        },
        // {
        //     value: 15,
        //     label: '注射医生、医生姓名',
        // },
        // {
        //     value: 16,
        //     label: '护士姓名、当班护士',
        // },
    ],

    productOption: [{
            value: 4,
            label: '注假名称',
        },
        {
            value: 7,
            label: '外科产品名称',
        },
        {
            value: 8,
            label: '注射微整科产品名称',
        },
    ],
    // 登记表所有数据
    reData: [],
    placeData: [],
    anesList: [],
    doctorList: [],
    nurseList: [],
    assistantList: [],

    dataAll: [],
    skinNurseList: [],
    skinDoctorList: [],
    skinList: [],
    uuid: '',
    ranks: [{
            id: '001',
            name: '上伯',
        },
        {
            id: '002',
            name: '上百',
        },
        {
            id: '003',
            name: '上翡',
        },
        {
            id: '004',
            name: '北百',
        },
        {
            id: '005',
            name: '温伯',
        },
        {
            id: '006',
            name: '重百',
        },
        {
            id: '007',
            name: '南伯',
        },
    ],
    departments: [],
    instruments: [{
            name: '①(Vbeam)染料激光治疗仪',
            label: "(Vbeam)染料激光治疗仪",
            id: 1
        },
        {
            name: '②YAG光治疗仪',
            label: "YAG光治疗仪",
            id: 2
        },
        {
            name: '③红宝石激光治疗机',
            label: "红宝石激光治疗机",
            id: 3
        },
        {
            name: '④冷冻减脂仪',
            label: "冷冻减脂仪",
            id: 4
        },
        {
            name: '⑤强光与激光系统',
            label: "强光与激光系统",
            id: 5
        },
        {
            name: '⑥(BBL)激光脉冲光治疗系统',
            label: "激光脉冲光治疗系统",
            id: 6
        },
        {
            name: '⑦翠绿宝石固体手术设备',
            label: "翠绿宝石固体手术设备",
            id: 7
        },
        {
            name: '⑧双波长点阵半导体激光治疗仪',
            label: "双波长点阵半导体激光治疗仪",
            id: 8
        },
        {
            name: '⑨(皮秒翠绿宝石激光治疗仪',
            label: "(皮秒)翠绿宝石激光治疗仪",
            id: 9
        },
        {
            name: '⑩(808)半导体激光治疗机',
            label: "(808)半导体激光治疗机",
            id: 10
        },
        {
            name: '⑪红蓝光治疗仪',
            label: "红蓝光治疗仪",
            id: 11
        },
        {
            name: '⑫(ipl)光治疗仪',
            label: "(ipl)光治疗仪",
            id: 12
        },
        {
            name: '⑬中频治疗仪',
            label: "中频治疗仪",
            id: 13
        },
        {
            name: '⑭高频电灼仪',
            label: "高频电灼仪",
            id: 14
        },
        {
            name: '⑮超声治疗仪',
            label: "超声治疗仪",
            id: 15
        },
        {
            name: '⑯射频治疗仪',
            label: "射频治疗仪",
            id: 16
        },
        {
            name: '⑰二氧化碳激光治疗机',
            label: "二氧化碳激光治疗机",
            id: 17
        },
        {
            name: '⑱LJL35-CB型CO2激光治疗机',
            label: "LJL35-CB型CO2激光治疗机",
            id: 18
        },
        {
            name: '电子注射器控制助推装置（芙迈蕾）',
            label: "电子注射器控制助推装置（芙迈蕾）",
            id: 19
        },
        {
            name: '注射器辅助推进装置',
            label: "注射器辅助推进装置",
            id: 20
        },
        {
            name: '强脉冲光与激光系统',
            label: "强脉冲光与激光系统",
            id: 21
        },
    ],
    needs: [{
            name: '1.微创激光光电治疗',
            id: '1'
        },
        {
            name: '2.化学剥脱治疗',
            id: '2'
        },
        {
            name: '3.有创激光光电治疗',
            id: '3'
        },
        {
            name: '4.美容物理治疗',
            id: '4'
        },
    ],
    losts: [{
            name: '0.5mm',
            id: '1'
        },
        {
            name: '1.0mm',
            id: '2'
        },
        {
            name: '1.5mm',
            id: '3'
        },
        {
            name: '皮下注射',
            id: '4'
        },
    ],

    lists: [{
            name: '皮肤微红',
            id: '1'
        },
        {
            name: '皮损',
            id: '2'
        },
        {
            name: '其他',
            id: '3'
        },
    ],
    loads: [{
            name: '全面部',
            id: '1'
        },
        {
            name: '鼻部',
            id: '2'
        },
        {
            name: '两侧面颊',
            id: '3'
        },
    ],
    diagnosis: [{
            name: '1.色素增生',
            id: 1
        },
        {
            name: '2.不良纹饰',
            id: 2
        },
        {
            name: '3.血管增生',
            id: 3
        },
        {
            name: '4.瘢痕',
            id: 4
        },
        {
            name: '5.多毛症',
            id: 5
        },
        {
            name: '6.皮肤光老化',
            id: 6
        },
        {
            name: '7.痤疮',
            id: 7
        },
        {
            name: '8.敏感性肌肤',
            id: 8
        },
    ],
    skinDiagnosis: [{
            name: '颈纹',
            id: 9
        },
        {
            name: '皱纹',
            id: 10
        },
        {
            name: '皮肤干燥',
            id: 11
        },
        {
            name: '肤色暗沉',
            id: 12
        },
        {
            name: '油脂分泌过多',
            id: 13
        },
        {
            name: '毛孔粗大',
            id: 14
        },
        {
            name: '皮肤色素沉着',
            id: 15
        },
        {
            name: '脱发',
            id: 16
        },
        {
            name: '膨胀纹',
            id: 17
        },
    ],
    injectDiagnosis: [{
            name: '鱼尾纹',
            id: 1
        },
        {
            name: '眉间纹',
            id: 2
        },
        {
            name: '额纹',
            id: 3
        },
        {
            name: '咬肌肥厚',
            id: 4
        },
        {
            name: '腓肠肌肥厚',
            id: 5
        },
        {
            name: '斜方肌肥厚',
            id: 6
        },
        {
            name: '下颌缘松弛',
            id: 7
        },
        {
            name: '腋臭',
            id: 8
        },
        {
            name: '颈纹',
            id: 9
        },
        {
            name: '额部凹陷',
            id: 10
        },
        {
            name: '眉弓凹陷',
            id: 11
        },
        {
            name: '颞部凹陷',
            id: 12
        },
        {
            name: '泪沟凹陷',
            id: 13
        },
        {
            name: '苹果肌凹陷',
            id: 14
        },
        {
            name: '面颊凹陷',
            id: 15
        },
        {
            name: '鞍鼻',
            id: 16
        },
        {
            name: '鼻唇沟凹陷',
            id: 17
        },
        {
            name: '平唇',
            id: 18
        },
        {
            name: '下颏后缩',
            id: 19
        },
        {
            name: '下颌缘缺失',
            id: 20
        },
        {
            name: '颊中沟',
            id: 21
        },
    ],
    injectNeeds: [{
            name: 'A型肉毒素',
            id: 1
        },
        {
            name: '下颏后缩',
            id: 2
        },
        {
            name: '下颌缘缺失',
            id: 3
        },
        {
            name: '颊中沟',
            id: 4
        },
    ],
    arr: [{
            name: '鱼尾纹',
            id: 1
        },
        {
            name: '额纹',
            id: 2
        },
        {
            name: '眉间纹',
            id: 3
        },
        {
            name: '斜方肌',
            id: 4
        },
        {
            name: '咬肌',
            id: 5
        },
        {
            name: '腓肠肌',
            id: 6
        },
        {
            name: '下颌缘提升',
            id: 7
        },
        {
            name: '其他',
            id: 8
        },
    ],
    arr1: [{
            name: '泪沟',
            id: 1
        },
        {
            name: '额部',
            id: 2
        },
        {
            name: '鼻部',
            id: 3
        },
        {
            name: '唇部',
            id: 4
        },
        {
            name: '颏部',
            id: 5
        },
        {
            name: '颞部',
            id: 6
        },
        {
            name: '面部',
            id: 7
        },
        {
            name: '鼻唇沟',
            id: 8
        },
        {
            name: '下颌缘',
            id: 9
        },
        {
            name: '颊中沟(印第安纹)',
            id: 10
        },
        {
            name: '其他',
            id: 11
        },
    ],
    arr2: [{
            name: '颈部',
            id: 1
        },
        {
            name: '其他',
            id: 2
        },
    ],
    arr3: [{
        name: '玻璃酸酶注射',
        id: 1
    }, ],
    nurseNoList: [],
    orderList: [],
    orderNurseData: [],
    orderDoctorData: [],
}

export default state